/**
 * LockIcon — sanitized from `assets/newSvg/lock.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function LockIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M6,8 C6,4.68629 8.68629,2 12,2 C15.3137,2 18,4.68629 18,8 L19,8 C20.1046,8 21,8.89543 21,10 L21,20 C21,21.1046 20.1046,22 19,22 L5,22 C3.89543,22 3,21.1046 3,20 L3,10 C3,8.89543 3.89543,8 5,8 L6,8 Z M12,4 C14.2091,4 16,5.79086 16,8 L8,8 C8,5.79086 9.79086,4 12,4 Z M14,14 C14,14.7403 13.5978,15.3866 13,15.7324 L13,17 C13,17.5523 12.5523,18 12,18 C11.4477,18 11,17.5523 11,17 L11,15.7324 C10.4022,15.3866 10,14.7403 10,14 C10,12.8954 10.8954,12 12,12 C13.1046,12 14,12.8954 14,14 Z"
        fill={color}
      />
    </Svg>
  );
}

export default LockIcon;
